import React from 'react'
import { Link, useLocation } from "react-router-dom";

export default function Subheader({subheadData}) {
    const location = useLocation();
    const isBlogPage = location.pathname.startsWith("/blog/");

  return (
    <>
    <section className="subheader">
        <div className="container">
          <div className="row justify-content-center">
                <div className="col-lg-6 col-md-8">
                    <div className="subheader-text">
                        {isBlogPage ? (
                            <span className="heading">{subheadData.heading}</span>
                        ) : (
                            <h1 className="heading">{subheadData.heading}</h1>
                        )}
                        <ul>
                            <li><Link to={"/"}>Home</Link></li>
                            {subheadData?.breadcrumb?.map((data, index)=>(
                                <li key={index}> <Link to={data.slug}>{data.name}</Link> </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
